(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6212],{

/***/ 76632:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validar-certificacion",
      function () {
        return __webpack_require__(68342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RemoteImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);






var defaultProps = {
    className: null
};
var propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
var cloudinaryLoader = function(param) {
    var src = param.src;
    if (/^(f|ht)tps?:\/\//i.test(src)) {
        return src;
    }
    return "https://res.cloudinary.com/aibesorg/image/upload/f_auto,q_auto,fl_lossy,f_avif/".concat(src);
};
function RemoteImage(_param) {
    var src = _param.src, alt = _param.alt, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: src,
        alt: alt,
        loader: cloudinaryLoader,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("block h-auto max-w-full", className),
        placeholder: "blur",
        blurDataURL: "data:image/svg+xml;base64,"
    }, rest));
};
RemoteImage.defaultProps = defaultProps;
RemoteImage.propTypes = propTypes;


/***/ }),

/***/ 68342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CertificationValidationTool; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48300);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30341);
/* harmony import */ var _components_Image_RemoteImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49187);
/* harmony import */ var _components_Forms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91212);






function CertificationValidationTool() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), license = ref[0], setLicense = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (license !== null) {
            window.open("//certificaciones.aibes.org/".concat(license));
            setLicense(null);
        }
    }, [
        license
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative z-10 bg-gradient-to-b from-green-100 to-white py-10 lg:py-20 xl:pt-28 xl:pb-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "relative z-10 space-y-10 lg:space-y-12",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-4 lg:col-span-7 lg:space-y-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-4xl font-extrabold tracking-tight lg:text-5xl xl:text-6xl",
                                    children: "Validaci\xf3n de certificaciones"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "font-med text-lg leading-relaxed text-gray-600 lg:pr-28",
                                    children: [
                                        "La herramienta de validaci\xf3n de certificaciones puede ser utilizada por empleadores, clientes y otras partes interesadas para validar la autenticidad de las\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            className: "font-medium text-gray-900",
                                            href: "/certificaciones",
                                            children: "certificaciones"
                                        }),
                                        "\xa0avaladas por la Asociaci\xf3n Iberoamericana de Scrum AIBES."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "rounded-full bg-white shadow-outside lg:col-span-9",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Forms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                initialValues: {
                                    license: ""
                                },
                                onSubmit: function(values, param) {
                                    var resetForm = param.resetForm;
                                    setLicense(values.license);
                                    resetForm();
                                },
                                children: function(param) {
                                    var values = param.values, handleChange = param.handleChange, handleBlur = param.handleBlur;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex w-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "hidden items-center space-x-2 border-r border-gray-200 py-5 pl-8 pr-6 md:flex",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                        className: "h-5 w-5 text-gray-300",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 20 20",
                                                        fill: "currentColor",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            fillRule: "evenodd",
                                                            d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                                                            clipRule: "evenodd"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-lg font-medium lg:text-xl lg:font-semibold",
                                                        children: "N\xfamero de licencia"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex flex-1",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "text",
                                                    className: "w-full rounded-l-full border-2 border-transparent px-5 text-lg placeholder-gray-300 focus:border-green-500 focus:outline-none focus:ring-4 focus:ring-green-500 focus:ring-opacity-20 md:rounded-none lg:text-2xl",
                                                    placeholder: "Ej. 21170830",
                                                    name: "license",
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    value: values.license,
                                                    required: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative z-0 px-3 py-3",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    className: "w-full rounded-full bg-green-500 px-5 py-3 text-lg font-medium leading-6 text-white hover:bg-green-600 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:px-8 lg:text-lg lg:font-semibold",
                                                    type: "submit",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            className: "h-5 w-5 md:hidden",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 20 20",
                                                            fill: "currentColor",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                                                clipRule: "evenodd"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "hidden md:block",
                                                            children: "Verificar"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-0 hidden md:flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    className: "relative flex h-full py-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid w-full grid-cols-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative col-span-5 col-start-8 flex",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_RemoteImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: "rounded-lg object-cover shadow-lg lg:rounded-xl",
                                src: "v1612316006/validar/herramienta-de-validacion_ukkpnu.jpg",
                                alt: "Validaci\xf3n de certificados",
                                layout: "fill"
                            })
                        })
                    })
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,5675,2175,6225,1212,9774,2888,179], function() { return __webpack_exec__(76632); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);